import { format } from "date-fns";

export const dateFormatter = (datestring) => {
    return format(new Date(datestring), "MM/dd/yyyy hh:mm:ss aa")
}

export const dateParser = (formattedDate) => {
    // console.log("FORMATTED DATE: ", formattedDate)
    const [datePart, timePart, ampm] = formattedDate !== null ? formattedDate.split(' '): [null, null, null];
    // console.log("DATE, time, ampm: ", datePart, timePart, ampm)

    if (!datePart || !timePart || !ampm) {
        console.log("DATE SPLIT IS LOGGING NULL!")
        return null
    };

    const [month, day, year] = datePart.split('/').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);

    // Check if date and time components are valid numbers
    if (
        isNaN(month) || isNaN(day) || isNaN(year) ||
        isNaN(hours) || isNaN(minutes) || isNaN(seconds)
    ) {
        console.log("DATE PARSER GOT NAN SO LOGGING NULL!")
        return null;
    }
    
    let adjustedHours = hours;
    if (ampm.toLowerCase() === 'pm' && hours !== 12) {
        adjustedHours = hours + 12;
    } else if (ampm.toLowerCase() === 'am' && hours === 12) {
        adjustedHours = 0;
    }
    // console.log("FORMATTED DATE: ", new Date(year, month - 1, day, adjustedHours, minutes, seconds))
    return new Date(year, month - 1, day, adjustedHours, minutes, seconds);
}